import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress';
import firebase from './fb'
Vue.use(Router)

const Home = () => import(/* webpackChunkName: "home" */ './views/Home.vue')
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ './views/Dashboard')
const Faq = () => import(/* webpackChunkName: "faq" */ './views/Faq')
const Register = () => import(/* webpackChunkName: "register" */ './views/Register')
const Login = () => import(/* webpackChunkName: "pm-cfa" */ './views/Login.vue')
const Funds = () => import(/* webpackChunkName: "funds" */ './views/Funds.vue')
const Account = () => import(/* webpackChunkName: "account" */ './views/Account')
const Exchange = () => import(/* webpackChunkName: "exchange" */ './views/Exchange')
const ETH_XOF = () => import(/* webpackChunkName: "eth-xof" */ './views/Eth-XOF.vue')
const BTC_GHS = () => import(/* webpackChunkName: "btc-ghs" */ './views/BTC-GHS.vue')
const PM_CFA = () => import(/* webpackChunkName: "pm-cfa" */ './views/PM_CFA.vue')
const USDT_CFA = () => import(/* webpackChunkName: "pm-cfa" */ './views/usdt_cfa.vue')
const Verify = () => import(/* webpackChunkName: "pm-cfa" */ './views/Verify.vue')
const Failed = () => import(/* webpackChunkName: "pm-cfa" */ './views/Failed.vue')
const Terms = () => import(/* webpackChunkName: "terms" */ './views/Terms.vue')
const Privacy = () => import(/* webpackChunkName: "privacy" */ './views/Privacy.vue')
const pageAchat = () => import(/* webpackChunkName: "privacy" */ './views/PageAchatVente.vue')
import { validActions, validCryptos, validCountries } from './routerParameters.js';

const validateParams = (to, from, next) => {
  const { action, crypto, pays } = to.params;

  // Validation des paramètres
  if (!validActions.includes(action)) {
    return next({ name: 'home', params: { message: 'Action invalide' } });
  }
  if (!validCryptos.includes(crypto)) {
    return next({
      name: 'home',
      params: { message: 'Cryptomonnaie invalide' },
    });
  }
  if (!(pays in validCountries)) {
    return next({ name: 'home', params: { message: 'Pays invalide' } });
  }

  next(); // Les paramètres sont valides, on continue
};

const validateParamsNoCountry = (to, from, next) => {
  const { action, crypto } = to.params;

  // Validation des paramètres
  if (!validActions.includes(action)) {
    return next({ name: 'home', params: { message: 'Action invalide' } });
  }
  if (!validCryptos.includes(crypto)) {
    return next({
      name: 'home',
      params: { message: 'Cryptomonnaie invalide' },
    });
  }

  next(); // Les paramètres sont valides, on continue
};


const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [

    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/faq',
      name: 'faq',
      component: Faq,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),

    },

    {
      path: '/achat',
      name: 'page_achat_vente',
      component: () => import(/* webpackChunkName: "about" */ './views/PageAchatVente.vue'),

    },

    {
      path: '/terms',
      name: 'terms',
      component: Terms,
    },

    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy,
    },

    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/dashboard/account',
      name: 'account',
      component: Account,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/dashboard/funds',
      name: 'funds',
      component: Funds,
      meta: {
        requiresAuth: true
      }
    },
    //  {
    //       path: '/dashboard/BTC-GHS',
    //       name: 'BTC_GHS',
    //       component: BTC_GHS,
    //       meta: {
    //         requiresAuth: true
    //     }
    //   },
    //   {
    //     path: '/dashboard/ETH-CFA',
    //     name: 'ETH_XOF',
    //     component: ETH_XOF,
    //     meta: {
    //       requiresAuth: true
    //   }
    // },
    // {
    //   path: '/dashboard/PM-CFA',
    //   name: 'PM_CFA',
    //   component: PM_CFA,
    //   meta: {
    //     requiresAuth: true
    // }
    // },

    // {
    //   path: '/dashboard/usdt-cfa',
    //   name: 'usdt_cfa',
    //   component: USDT_CFA,
    //   meta: {
    //     requiresAuth: true
    // }
    // },
    {
      path: '/verify',
      name: 'verify',
      component: Verify,
      meta: {
        requiresAuth: true
      },
    },

    {
      path: '/exchange',
      name: 'exchange',
      component: Exchange,
      meta: {
        requiresAuth: true
      },
    },

    {
      path: '/failed',
      name: 'failed',
      component: Failed,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/register/:id',
      component: Register,
    },

    {
      path: '/:action-:crypto-:prep-:pays',
      name: 'cryptoTransaction',
      component: pageAchat,
      meta: { title: 'Transaction de cryptomonnaie' },
      beforeEnter: validateParams,
    },
  
    {
      path: '/:action-:crypto',
      name: 'cryptoTransaction',
      component: pageAchat,
      meta: { title: 'Transaction de cryptomonnaie' },
      beforeEnter: validateParamsNoCountry,
    },

    { path: '*', redirect: '/exchange' }
  ],
}
);
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const currentUser = firebase.auth().currentUser


  const handle_newUser = () => {
    //to.name == 'verify'  || to.name == 'exchange'?next() : next('/verify')
    to.name == 'verify' ? next() : next('/verify')
  }

  if (requiresAuth && !currentUser) {
    next('/login')
  } else if (requiresAuth && currentUser) {
    currentUser.displayName == 'new' ? handle_newUser() : next()

  } else if (!requiresAuth && currentUser) {
    console.log('no auth');
    next('/exchange')
  } else {
    next()
  }
});
router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start()
  }
  next()
})

router.afterEach(() => {
  NProgress.done()
})

export default router
